// extracted by mini-css-extract-plugin
export default {"noFilmsFound":"NoResultsView_noFilmsFound__v49Wz"};